import { render } from "./EditLocation.vue?vue&type=template&id=0e092cb0"
import script from "./EditLocation.vue?vue&type=script&lang=js"
export * from "./EditLocation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__